import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import InputMask from "react-input-mask";
import IntlCurrencyInput from "react-intl-currency-input";
import { TabTextField, valueFormStyle } from "../styles/DocumentModal";

export const DocumentDasTab = (props) => {
  const [companyName, setCompanyName] = useState(
    props.document.data.company_name
  );

  const [expireDate, setExpireDate] = useState(props.document.data.expire_date);
  const [period, setPeriod] = useState(props.document.data.period);
  const [paymentLimitDate, setPaymentLimitDate] = useState(
    props.document.data.payment_limit_date
  );
  const [totalAmount, setTotalAmount] = useState(
    props.document.data.total_amount
  );
  const [documentName, setDocumentName] = useState(
    props.document.use_suggestion
      ? props.document.name_suggestion
      : props.document.name
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TabTextField
          label="Nome da empresa"
          variant="outlined"
          key={"NAME_COMPANY_" + props.index}
          value={companyName}
          onChange={(ev) => {
            setCompanyName(ev.target.value);
            props.document.data.company_name = ev.target.value;
          }}
        />
      </Grid>

      <Grid item xs={4}>
        <InputMask
          mask="99/99/9999"
          disabled={false}
          maskChar=""
          value={expireDate}
          onChange={(ev) => {
            setExpireDate(ev.target.value);
            props.document.data.expire_date = ev.target.value;
          }}
        >
          {() => (
            <TabTextField
              label="Data de vencimento"
              variant="outlined"
              key={"CODE_EXPIRE_DATE" + props.index}
            />
          )}
        </InputMask>
      </Grid>

      <Grid item xs={4}>
        <InputMask
          mask="99/99/9999"
          disabled={false}
          maskChar=""
          value={period}
          onChange={(ev) => {
            setPeriod(ev.target.value);
            props.document.data.period = ev.target.value;
          }}
        >
          {() => (
            <TabTextField
              label="Período de apuração"
              variant="outlined"
              key={"PERIOD_APURATION" + props.index}
            />
          )}
        </InputMask>
      </Grid>

      <Grid item xs={4}>
        <InputMask
          mask="99/99/9999"
          disabled={false}
          maskChar=""
          value={paymentLimitDate}
          onChange={(ev) => {
            setPaymentLimitDate(ev.target.value);
            props.document.data.payment_limit_date = ev.target.value;
          }}
        >
          {() => (
            <TabTextField
              label="Data limite de pagamento"
              variant="outlined"
              key={"CODE_FULL_VALUE" + props.index}
            />
          )}
        </InputMask>
      </Grid>

      <Grid item xs={12}>
        <div
          class="MuiFormControl-root MuiTextField-root "
          style={valueFormStyle}
        >
          <label
            style={{ background: "#f2f2f2" }}
            class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-marginDense MuiInputLabel-outlined MuiFormLabel-filled"
            data-shrink="true"
          >
            Valor total
          </label>

          <div class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-formControl MuiInputBase-marginDense MuiOutlinedInput-marginDense">
            <IntlCurrencyInput
              currency="BRL"
              value={totalAmount}
              class="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputMarginDense MuiOutlinedInput-inputMarginDense"
              config={{
                locale: "pt-BR",
                formats: {
                  number: {
                    BRL: {
                      style: "currency",
                      currency: "BRL",
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    },
                  },
                },
              }}
              onChange={(event, value, maskedValue) => {
                event.preventDefault();
                setTotalAmount(value);
                props.document.data.total_amount = maskedValue;
              }}
            />
          </div>
        </div>
      </Grid>

      {props.documentModalLoading === false && (
        <>
          <Grid item xs={12}>
            <TabTextField
              final
              label={
                props.document.use_suggestion
                  ? "Nome do documento (sugestão)"
                  : "Nome do documento (original)"
              }
              variant="outlined"
              key={"DOCUMENT_NAME" + props.index + " - " + props.documentKey}
              value={documentName}
              onChange={(ev) => {
                setDocumentName(ev.target.value);
                props.document.name_suggestion = ev.target.value;
              }}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};
